import _axios from 'axios'

const csrfToken = document.head.querySelector('meta[name="csrf-token"]')
const apiToken = document.head.querySelector('meta[name="api-token"]');

const axios = _axios.create({
	headers: {
		common: {
			'X-Requested-With': 'XMLHttpRequest',
			'X-CSRF-TOKEN': csrfToken ? csrfToken.content : null,
			Authorization: apiToken ? `Bearer ${apiToken.content}` : null,
		}
	},
	withCredentials: true,
	withXSRFToken: true,
})

export {
	axios
}

export default {
	install(Vue) {
		Vue.prototype.$axios = axios
	}
}
